import React, { useEffect, useRef, useState } from "react";
import Page from "../../components/Page";
import { IonHeader, IonIcon, IonSpinner } from "@ionic/react";
import { FirebaseAuthentication } from "@capacitor-firebase/authentication";
import styled, { css } from "styled-components";
import { useHistory } from "react-router";
import { chevronBackOutline, chevronForwardOutline, navigate } from "ionicons/icons";
import withNav from "../../utils/hoc/withNav";
import { connect } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import * as UserActions from "../../actions/UserActions";
import * as XookActions from "../../actions/XookActions";
import { setCart } from "../../actions/CartActions";
import ToastService from "../../services/ToastService";
import { getAuth } from "firebase/auth";
import UserService from "../../services/UserService";
import { PaymentStatus, PaymentStatusMap, orderStatusMap } from "../../config";
import { ModalOverlay, Modal, ModalButtonGroup, ModalHeader, ModalPrimaryButton, ModalSecondaryButton, ModalSubtitle } from "../../components/Modal";
import Analytics, { TRACK_PAGE_CATEGORIES } from "../../lib/anayltics";
import ATHS from "../../components/ATHS";
import { uptilTwoDecimalPlaces } from "../../utils/misc";
import FreshchatService from "../../services/FreshworksService";

declare global {
	interface Window {
		fcWidget: any
	}
}

const PageHeader = styled(IonHeader)`
	position: fixed;
	margin: 0 0 0 0;
	background: ${({ theme }) => theme.colors.main.background};
	color: #f2f2f2;
	font-style: normal;
	font-size: 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem 1rem;
	border: none;
	box-shadow: none;
	&:after {
		background-image: none;
	}
`;

const Center = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 100%;
`;

const BackButton = styled.div`
	margin-right: auto;
`;

const BackButtonImg = styled(IonIcon)`
	width: 24px;
	height: 24px;
	color: #fff;
`;

const PageTitle = styled.div`
	font-style: normal;
	font-weight: 900;
	font-size: 20px;
	letter-spacing: 0px;
	display: flex;
	justify-content: center;
`;

const HelpButton = styled(IonIcon)`
	width: 20px;
	height: 20px;
	margin-left: auto;
`;

const PaddedElement = styled.div`
	margin: 4rem 0 0 0;
`;

const Name = styled.div`
	color: #f2f2f2;
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
`;

const PhoneNumber = styled.div`
	color: #d6d6d6;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;

const Email = styled.div`
	color: #d6d6d6;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;

const EditButton = styled.div`
	color: #e8e8e8;
	text-align: right;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	text-decoration-line: underline;
`;

const Seperator = styled.div`
	border-bottom: 1px solid #838383;
	width: 100%;
`;

const DottedSeperator = styled.div`
	border-bottom: 1px dotted #f2f2f2;
	width: 100%;
`;

const FadedSeperator = styled.div`
	border-bottom: 1px solid rgba(242, 242, 242, 0.4);
	width: 100%;
`;

const DietaryPreferences = styled.div<any>`
	display: flex;
	flex-wrap: wrap;
	gap: 1rem;
	max-height: ${(props) => (props.active ? "300px" : "0")};
	opacity: ${(props) => (props.active ? "1" : "0")};
	overflow: hidden;
	height: max-content;
	width: 100%;
	padding: ${(props) => (props.active ? "1rem 0 0 0" : "")};
	transition: 200ms all linear;
`;

const Preference = styled.div<any>`
	font-size: 14px;
	border-radius: 2px;
	border: 1px solid #e8e8e8;
	text-align: center;
	padding: 0.5rem 0.3rem;
	min-width: 60px;
	${(props) =>
		props.active &&
		css`
			border: none;
			background: #4b4b4b;
		`}
`;

const CenteredRow = styled.div<any>`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const RowBlock = styled.div<any>`
	padding: ${props => props.padding || "1rem 0"};
	width: 100%;
	display: flex;
	height: max-content;
	justify-content: space-between;
	align-items: ${(props) => (props.centered ? "center" : "flex-start")};
`;

const ColumnBlock = styled.div<any>`
	padding: 1rem 0;
	width: 100%;
	display: flex;
	flex-direction: column;
	height: max-content;
	align-items: ${(props) => (props.centered ? "center" : "flex-start")};
	gap: ${(props) => props.gap};
`;

const Column = styled.div<any>`
	height: max-content;
	width: max-content;
	display: flex;
	flex-direction: column;
	text-align: left;
	gap: ${(props) => props.gap};
`;

const Title = styled.div`
	color: #e8e8e8;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
`;

const SubTitle = styled.div<any>`
	color: #d6d6d6;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	text-align: ${(props) => props.align};
	margin: ${(props) => props.margin || "5px 0 0 0"};
`;

const Caution = styled.span`
	color: #F65555;
`;

const Arrow = styled(IonIcon)`
	font-size: 18px;
	color: #e8e8e8;
	transition: 300ms all linear;
`;

const Orders = styled.div`
	height: max-content;
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

const OrderCard = styled.div`
	border-radius: 6px;
	background: #4b4b4b;
	width: 100%;
	height: max-content;
	padding: 0 1rem;
`;

const OrderStatus = styled.div`
	font-weight: 400;
	font-size: 12px;
	color: ${(props) => props.color};
	border: 1px solid ${(props) => props.color};
	padding: 0.3rem 0.4rem;
	margin: 0 auto 0 0;
	text-align: center;
`;

const Account = (props: any) => {
	const history = useHistory();
	const [ordersLoading, setOrdersLoading] = useState(false);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const [orders, setOrders] = useState<any>([]);
	const [orderPageIndex, setOrderPageIndex] = useState<number>(1);
	const ordersLimitReached = useRef<boolean>(false);
	const [orderCount, setOrderCount] = useState<any>(null);
	const [lastOrderElement, setLastOrderElement] = useState<any>();
	const { xookId, allergies, dietaryPreferences, setUserData, setCart, dataLoaded, currency, clearUserData } = props;
	const [showLogoutModal, toggleLogoutModal] = useState(false);
	const [logoutLoading, toggleLogoutLoading] = useState(false);
	const [chatLoading, setChatLoading] = useState(false);

	const observer = useRef(
		new IntersectionObserver(
			(entries) => {
				if (entries[0].isIntersecting && !ordersLimitReached.current) {
					//Getting the earlier state and incrementing it
					setOrderPageIndex((prev) => prev + 1);
				}
			},
			{
				//Threshold set to 1 for the page to increment only when the element is 100% visible
				//Threshold = % of element to be visible / 100
				threshold: 1,
			}
		)
	);

	async function getUserPreferences(kioskId: string) {
		const response = await UserService.getUserPreferences();
		const { data, error } = response;
		if (data) {
			const { cartData, ...rest } = data;
			setUserData(rest);
		}
		if (error) {
			setError(error);
		}
	}

	async function getPastOrders(pageIndex: number) {
		setOrdersLoading(true);
		const payload = { pageIndex, nPerPage: 5 };
		const response = await UserService.getPastOrders(payload);
		const { data, error } = response;
		if (data) {
			const { ordersData, count } = data;
			if (!orderCount) setOrderCount(count);

			setOrders((prev: any) => [...prev, ...ordersData]);
		}
		if (error) {
			setError("");
		}
		setOrdersLoading(false);
	}

	function onPageLoad() {
		Analytics.trackPage(TRACK_PAGE_CATEGORIES.PAGE_LOAD, "Account");
		if (!dataLoaded) {
			getUserPreferences(xookId);
		}
	}

	useEffect(() => {
		onPageLoad();
	}, []);

	function goBack() {
		history.push(`/kiosk/${xookId}`)
	}

	function renderUserSelectedAllergies(allergies: any, dietaryPreferences: any) {

		let message = "", allergyCount = 0;
		const maxAllergiesToShow = 3;

		if (allergies && dietaryPreferences) {

			dietaryPreferences.forEach((preferenceId:any, index:any, array:any) => {
				if(allergies?.[preferenceId]) {
					
					allergyCount++;
					
					if(maxAllergiesToShow < allergyCount) return;		

					if(message.length) message += ', ';
					message += `${allergies[preferenceId]}`;
					if(index === (array.length - 1)) message += '.';

					if(allergyCount === maxAllergiesToShow &&  index !== (array.length - 1)) {
						message += "...";
					}

				}
			});
		}

		if(!message.length) return "No allergens to show.";
		else return <> Avoiding : <Caution>{message}</Caution> </>
	}

	const LogoutUser = async () => {
		try {
			toggleLogoutLoading(true);
			await FirebaseAuthentication.signOut();
			localStorage.removeItem("userId");
			clearUserData();
			history.push("/login");
			toggleLogoutLoading(false);
		} catch (err) {
			ToastService.showToast("Something went wrong");
			toggleLogoutLoading(false);
		}
	};

	function navigateToDietaryPreferences() {
		history.push("/account/dietaryPreferences");
	}

	async function openHelpChat() {
		setChatLoading(true);
		try {
			const { error } = await FreshchatService.openFreshchatHelpDesk();
			if (error) {
				ToastService.showToast(error);
			}
		} finally {
			setChatLoading(false);
		}
	}

	function renderAccountDetails() {
		let renderData = [];
		const userData = getAuth().currentUser;

		renderData.push(
			<>
				<RowBlock>
					<Column>
						<Name>{userData?.displayName}</Name>
						<Name>{userData?.phoneNumber}</Name>
						<SubTitle>{userData?.email}</SubTitle>
					</Column>
					<EditButton onClick={() => toggleLogoutModal(true)}>Logout</EditButton>
				</RowBlock>
				<Seperator />
				<RowBlock centered onClick={navigateToDietaryPreferences}>
					<Column>
						<Title>Dietary Restrictions</Title>
						<SubTitle >{renderUserSelectedAllergies(allergies, dietaryPreferences)}</SubTitle>
					</Column>
					<Arrow src={chevronForwardOutline} />
				</RowBlock>
				<Seperator />
				<RowBlock centered onClick={openHelpChat}>
					<Column>
						<Title>Help</Title>
						<SubTitle>Chat with us.</SubTitle>
					</Column>
					<Arrow src={chevronForwardOutline} />
				</RowBlock>
				
				{/* <RowBlock centered>
					<Column>
						<Title>Payments & Refunds</Title>
						<SubTitle>1 Refund in progess</SubTitle>
					</Column>
					<Arrow src={chevronForwardOutline} />
				</RowBlock>
				<Seperator />
				<RowBlock centered>
					<Column>
						<Title>App Settings</Title>
						<SubTitle>Notifications and other app settings</SubTitle>
					</Column>
					<Arrow src={chevronForwardOutline} />
				</RowBlock>
				<Seperator />
				<RowBlock centered>
					<Column>
						<Title>Help</Title>
						<SubTitle>FAQs and Helpline</SubTitle>
					</Column>
					<Arrow src={chevronForwardOutline} />
				</RowBlock> */}
				<Seperator />
			</>
		);
		return renderData;
	}

	function goToOrderDetails(orderid: any) {
		history.push(`/account/order/${orderid}`);
	}

	function goToTrackOrder(restaurantId: any, orderid: any) {
		history.push(`/kiosk/${restaurantId}/order/track/${orderid}`);
	}

	function renderOrders(ordersData: any) {
		let renderData: any = [];

		if (ordersData.length) {
			ordersData.forEach((orderData: any, index: any, array: any) => {
				const { _id, createdAt, status, items, paymentDetails, restaurantId, restaurantName } = orderData;
				const { paymentStatus } = paymentDetails;
				const { amountPaid } = paymentDetails;
				const { statusMessage, color, track } = orderStatusMap[status];
				const createdAtDate = new Date(createdAt).toLocaleString("en-US");
				let currencySymbol = orderData?.currencySymbol || "";
				let orderItems = [],
					showRefundDetails = false,
					message = "";

				switch (paymentStatus) {
					case PaymentStatus.REFUND_INITIATED:
						//showRefundDetails = true;
						message = PaymentStatusMap["REFUND_INITIATED"].shortDesc;
						break;

					case PaymentStatus.REFUND_PROCESSED:
						//showRefundDetails = true;
						message = PaymentStatusMap["REFUND_PROCESSED"].shortDesc;
						break;

					case PaymentStatus.REFUND_FAILED:
						//showRefundDetails = true;
						message = PaymentStatusMap["REFUND_FAILED"].shortDesc;
						break;

					default:
						break;
				}

				if (items.length) {
					items.forEach((item: any) => {
						const { itemDetails } = item;
						const { title } = itemDetails;

						return orderItems.push(
							<CenteredRow>
								<SubTitle margin={"0"}>{title}</SubTitle>
							</CenteredRow>
						);
					});
				} else {
					orderItems.push(<Title>Order has no items</Title>);
				}

				let isLastItem = index === array.length - 1 ? true : false;

				renderData.push(
					<OrderCard
						onClick={() => (track ? goToTrackOrder(restaurantId, _id) : goToOrderDetails(_id))}
						ref={(node) => (isLastItem ? setLastOrderElement(node) : "")}>
						<RowBlock>
							<Column>
								<Title>{_id}</Title>
								<SubTitle>{restaurantName}</SubTitle>
								<SubTitle>{createdAtDate}</SubTitle>
							</Column>
							<Column gap="0.3rem 0">
								<OrderStatus color={color}>{statusMessage}</OrderStatus>
								<SubTitle align={"right"}>
									{" "}
									{typeof amountPaid !== 'undefined' ? `${currencySymbol} ${uptilTwoDecimalPlaces(amountPaid)}` : ""} 
								</SubTitle>
							</Column>
						</RowBlock>
						{/* <FadedSeperator /> */}
						{/* <ColumnBlock gap={"0.3rem 0"}>{orderItems}</ColumnBlock> */}
						{showRefundDetails ? (
							<>
								<FadedSeperator />
								<RowBlock>{message}</RowBlock>
							</>
						) : (
							""
						)}
					</OrderCard>
				);
			});
		} else {
			renderData.push(<Title>No Orders found</Title>);
		}
		return renderData;
	}

	useEffect(() => {
		//Update the element on which the call is made and set the observer on it once the list re-renders
		const currentElement = lastOrderElement;
		const currentObserver = observer.current;

		if (currentElement) {
			currentObserver.observe(currentElement);
		}

		//Remove the observer once user exits the page
		return () => {
			if (currentElement) {
				currentObserver.unobserve(currentElement);
			}
		};
	}, [lastOrderElement]);

	useEffect(() => {
		getPastOrders(orderPageIndex);
	}, [orderPageIndex]);

	useEffect(() => {
		if (orders.length === orderCount) ordersLimitReached.current = true;
	}, [orders, orderCount]);

	return (
		<Page>
			<PageHeader>
				<BackButton>
					<BackButtonImg onClick={goBack} src={chevronBackOutline} />
				</BackButton>
			</PageHeader>
			<PaddedElement />
			{renderAccountDetails()}
			<RowBlock padding="0 0" >
				<ATHS />
			</RowBlock>
			
			<RowBlock>
				<Title>Past Orders</Title>
			</RowBlock>
			{orderCount !== null ? <Orders>{renderOrders(orders)}</Orders> : ""}
			{ordersLoading ? (
				<Center>
					{" "}
					<IonSpinner name="dots"></IonSpinner>{" "}
				</Center>
			) : (
				""
			)}
				
			{showLogoutModal ?                 
                <ModalOverlay>
                    <Modal>
                        <ModalHeader>Are you sure??</ModalHeader>
                        <ModalSubtitle>It`s sad to see you go, once logged out you can login using the same phone number to continue enjoying yummy food from Xook. </ModalSubtitle>
                        <ModalButtonGroup>
                        <ModalSecondaryButton onClick={() => {
                            toggleLogoutModal(false)
                        }} >CANCEL</ModalSecondaryButton>
                        <ModalPrimaryButton onClick={LogoutUser} >{logoutLoading ? <IonSpinner name='dots' /> : "LOGOUT"}</ModalPrimaryButton>
                        </ModalButtonGroup>
                    </Modal> 
                </ModalOverlay> : ""
            }
			{chatLoading ? (
				<ModalOverlay>
					<Center>
						<IonSpinner name="dots" color={"#F2F2F2"} />
					</Center>
				</ModalOverlay>
			) : ""}
		</Page>
	);
};

//Redux mapping
const mapStateToProps = (state: any) => {
	const {
		User,
		Xook,
		Food: { allergies },
	} = state;
	return { ...Xook, ...User, allergies };
};

const mapDispatchToProps = (dispatch: any) => ({
	...bindActionCreators(
		{
			...XookActions,
			...UserActions,
			setCart,
		},
		dispatch
	),
});

export default connect(mapStateToProps, mapDispatchToProps)(withNav(Account));
